<template>
	<div class="box">
		<div></div>
		<section v-loading="loading2" class="carousel">
			<div class="car_img">
				<el-carousel trigger="click" @change="getcurrentIndex" height="400px" class="banner-box"  ref="carousel" :interval="10000" arrow="always">
					<el-carousel-item  v-for="(item) in dataList" :key="item.id">
						<img @click="xin.goNew(item.url)" :src="item.images" :alt="item.title">
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="car_bot">
				<div class="car_title " :class="{'choose':currentIndex == i}" @click="setActiveItem(i)"
				v-for="(itme,i) in dataList" :key="i">{{itme.title}}</div>
			</div>
		</section>
		<div class="box_vessel">
			<section class="activity">
				<article @click="xin.goUrl(item.url)" class="act_zi cur_po" v-for="item in tablist" :key="item.id">
						<img :src="item.images" />
						<div class="act_title">{{item.title}}</div>
						<div class="act_nero">{{item.subtitle}}</div>
				</article>
			</section>
			<section class="longa clearfloat">
				<div class="kuang search_long">
					<!-- <input list="typelist" placeholder="按货号/产品名/其他搜索" />
					<datalist id="typelist">
						　　<option>Dimond</option>
						　　<option>vertical</option>
					</datalist> -->
					<span class="el-icon-search"></span>
					<div class="searchInp">
						<el-input class="nav_search" v-model="searchVal" @change="tosearch"
					 select-when-unmatched placeholder="按货号/产品名/其他搜索"></el-input>
					</div>
				</div>
				<div @click="xin.goUrl('/askData')" class="kuang btn_long">
					<span class="el-icon-message"></span>
					<span>操作说明集索取</span>
				</div>
			</section>
			<div class="big_btn">
				<div v-for="(itme,i) in proTab" :key="i" :class="i==proIndex?'btn_choose btn_tab':'btn_tab' " 
				@click="tabClick(i)" >{{itme}}</div>
			</div>
			<!-- 产品中心 -->
			<section class="min_he400" v-loading="loading" v-show="proIndex == 0">
				<div class="product_list">
					<article class="pro_zi" v-for="itme in chanList" :key="itme.id" >
						<div class="pro_img" @click="xin.goUrl('/oneDetails?cid='+itme.id)">
							<img :src="itme.images" />
						</div>
						<div class="pro_characters">
							<span class="pro_title">{{itme.title}}</span>
							<span class="geng" @click="xin.goUrl('/oneDetails?cid='+itme.id)">更多<span class="el-icon-arrow-right"></span></span>
						</div>
					</article>
				</div>
				<div class=" chani" @click="xin.goUrl('/product')">
					<span>查看更多</span>
				</div>
			</section>
			<!-- 产品最新动态 -->
			<section v-loading="loading" v-show="proIndex == 1" class="min_he400 zui_dynamic">
				<article class="dynamic clearfloat" v-for="item in zuixinList.data" :key="item.id">
					<div class="dyn_imgs" @click="xin.goUrl('/jourDetails?nid='+item.id);">
						<template v-if="item.images">
							<img :src="item.images" />
							<!-- <div class="dyn_time">
								<span class="dyn_ti_title">{{item.create_time|timeFormat('d')}}</span>
								<span>{{item.create_time|timeFormat('yyyy-mm')}}</span>
							</div> -->
						</template>
						<div v-else class="dyn_time_wen">{{item.create_time|timeFormat('年月日')}}</div>
					</div>
					<div class="dyn_characters">
						<span class="dyn_title" @click="xin.goUrl('/jourDetails?nid='+item.id);">{{item.title}}</span>
						<span class="dyn_content">{{item.subtitle}}</span>
						<div class="dyn_title2">产品分类： <span class="laing" @click="xin.goUrl('/oneDetails',{cid:item.category.id})">{{item.category.title}}</span></div>
						<div class="dyn_title2">
							产品货号：
							<div>
								<span class="laing" @click="xin.goUrl('/products/'+val.id)" v-for="val in item.product" :key="val.id">{{val.model}}</span>
							</div>
						</div>
						<div class="dyn_btn laing_btn"   @click="xin.goUrl('/jourDetails?nid='+item.id);">查看更多</div>
					</div>
				</article>
				<div class="dynamic clearfloat">
					<div class="dyn_imgs">

					</div>
					<div class="dyn_characters">
						<span class="dyn_title">线粒体自噬诱导及线粒体膜电位联合检测实验</span>
						<span class="dyn_content mar_bott_40">使用Parkin过表达的HeLa细胞并使用线使用Parkin过表达的HeLa细胞并使用线粒体检测试剂盒MitophagyDetectionKit（使用Parkin过表达的HeLa细胞并使用线粒体检测试剂盒MitophagyDetectionKit（粒体检测试剂盒MitophagyDetectionKit（货号：MD01)和线粒体膜电位检测试剂盒JC-1MitoMPDetectionKit（货号：MT09）。分别检测添加和不添加CCCP（羰基氰化物间氯苯）的线粒体状态。</span>

						<div class="dyn_btn laing_btn ">查看更多</div>
					</div>
				</div> -->
				<div @click="xin.goUrl('/journalism/news')" class=" chani">
					<span >查看更多</span>
				</div>
				<!--  -->
			</section>
			<!-- 文献资料 -->
			<section class="min_he400" v-loading="loading" v-show="proIndex == 2">
				<article class="literature clearfloat" v-for="item in wenxianList.data" :key="item.id">
					<div class="lit_left">
						<div class="lit_btn laing_btn" @click="xin.goUrl('/oneDetails',{cid:item.category.id})" >{{item.category.title}}</div>
					</div>
					<div class="lit_right">
						<div class="lit_title laing"  @click="xin.goUrl('/jourDetails?nid='+item.id)">{{item.title}}</div>
						<div>{{item.subtitle}}</div>
						<div>
							<span class="lit_author">作者：</span>
							<span >{{item.publisher}}</span>
						</div>
						<div >
							<span class="lit_author">期刊：</span>
							{{item.source}}
						</div>
						<div>
							<span class="lit_author"> 产品货号： </span>
							<div>
								<span class="laing" @click="xin.goUrl('/products/'+val.id)" v-for="val in item.product" :key="val.id" >{{val.model}}</span>
							</div>
						</div>

					</div>
				</article>
				<div @click="xin.goUrl('/journalism/product')" class=" chani">
					<span >查看更多</span>
				</div>
			</section>
			<!-- 产品学习资料 -->
			<section class="min_he400" v-loading="loading" v-show="proIndex == 3">
				<article class="datum clearfloat" v-for="itme in xuexieList.data" :key="itme.id">
					<div class="dat_left" >
						<div class="lit_btn laing_btn" @click="xin.goUrl('/oneDetails?cid='+itme.category_id)">{{itme.category_title}}</div>
					</div>
					<div class="dat_center">
						<div class="dat_title"  @click="xin.goUrl('/products/'+itme.id)">{{itme.goods_title}}</div>
						<div class="dat_right" v-for="val in itme.materials" :key="val.id">
							<div>{{val.subtitle}}</div>
							<div class="dat_btn li1" @click="xin.goNew(val.file)">{{val.title}}</div>
						</div>
					</div>
					<!-- <div >
						<div class="dat_btn li2">讲座资料</div>
					</div> -->
				</article>
				<div @click="xin.goUrl('/studyData')" class=" chani">
					<span >查看更多</span>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	let self = null;
	import {
		mapState,
		mapMutations
	} from 'vuex'
	export default {
		name: '',
		data() {
			return {
				loading2:true,
				loading: true,
				searchVal:"",//搜索
				currentIndex: 0, //轮播图索引
				dataList: [],//轮播图
				carousel: [],
				proIndex: 0,//产品索引
				proTab: ['产品中心', '产品最新动态', '文献资料', '产品学习资料'],
				timeId: -1,//
				tablist:[],//
				state: '',//远程搜索框
				timeout:  null,
				chanList:[],//产品中心
				zuixinList:[],//最新动态
				wenxianList:[],//文献资料
				xuexieList:[],//学习资料
			};
		},
		watch:{
			
		},
		created(){
			this.getlunbo();
			this.getindexgoods();
		},
		computed: {
			...mapState(['className']),
			
		},
		mounted() {
		},
		methods: {
			...mapMutations(['setclassName', 'setactiveIndex']),
			tosearch(e){//搜索
				e = e.replace(/\s+/g,"")
				if(e)this.xin.goUrl('/search?val='+e);
			},
			async getlunbo(){//获取轮播图
				this.loading2 = true;
				let {data} = await this.api.getlunbo();
				this.dataList = data.slide;
				this.tablist = data.tab;
				this.loading2 = false;
			},
			async getindexgoods(){//首页获取产品列表
				this.loading = true;
				let proIndex = this.proIndex+1;
				let {data} = await this.api.getindexgoods({type:proIndex});
				switch (proIndex) {
					case 1:
						this.chanList = data;
					break;
					case 2:
						this.zuixinList = data;
					break;
					case 3:
						this.wenxianList = data;
					break;
					case 4:
						this.xuexieList = data;
					break;
					// case '/index':

					// break;
					// default:
				}
				this.loading = false;
			},
			getcurrentIndex(i){
				this.currentIndex = i;
			},
			setActiveItem(i){
				this.$refs.carousel.setActiveItem(i);
			},
			tabClick(i) {
				if (i == this.proIndex) return;
				this.proIndex = i;
				this.getindexgoods();
				// this.loading = true;
				// clearTimeout(this.timeId);
				// this.timeId = setTimeout(() => {
				// 	this.loading = false;
				// }, 1000);
			}
		}
	}
</script>
<style lang='scss' scoped>
	/* @import './base.scss'; */
	
	@keyframes hideIndex {
		0% {
			opacity: 0;
		}

		100% {
			opacity: 1;
		}
	}

	.box_vessel {
		width: 1200px;
		margin: 0 auto;
		/* 文献信息 @*/

		.literature {
			width: 1023px;
			margin-top: 50px;

			.lit_left {
				float: left;

			}

			.lit_right {
				float: right;
				width: 743px;
				color: #666666;
				font-size: 20px;

				.lit_title {
					text-decoration: none;
					// cursor: default;
				}

				.lit_author {
					font-weight: 600;
					color: #000;
				}

				&>div {
					line-height: 36px;
				}
			}
		}


		/* 产品列表 */
		.product_list {

			display: flex;
			// justify-content: space-between;
			flex-wrap: wrap;

			.pro_zi {
				width: 380px;
				margin-top: 50px;

				.pro_img {
					width: 100%;
					height: 292px;
					overflow: hidden;
				}

				img {
					cursor: pointer;
					transition: all 0.6s;
					width: 100%;
					height: 100%;

					&:hover {
						transform: scale(1.2);
					}
				}

				.pro_characters {
					display: flex;
					justify-content: space-between;
					align-items: center;
					height: 44px;
					padding: 0 16px;

					.pro_title {
						font-size: 20px;
						color: #444;
					}

					.geng {
						color: #A1A1A1;
						cursor: pointer;
					}

				}
			}
		}

		/* 大按钮 */
		.big_btn {
			margin-top: 73px;
			display: flex;
			justify-content: space-around;

			.btn_tab {
				cursor: pointer;
				border: #707070 1px solid;
				border-radius: 20px;
				color: #666666;
				font-size: 22px;
				width: 289px;
				height: 77px;
				line-height: 77px;
				text-align: center;
			}

			.btn_choose {
				background: #005699;
				color: #fff;
			}
		}

		/* 远程搜索 */
		.longa {
			margin-top: 60px;

			.kuang {
				width: 550px;
				height: 50px;
				border: 1px solid #A0A0A0;
				border-radius: 25px;
				.inline-input{
					width: 500px;
					margin: 5px 5px 5px 15px;
					/deep/ .el-input__inner{
						border :none;
					}
				}
				input {
					margin: 5px 5px 5px 15px;
					border: none;
					width: 500px;
					height: 40px;
					font-size: 18px;
				}
			}

			.search_long {
				float: left;
				line-height: 50px;
				.el-icon-search{
					float: left;
					line-height: 50px;
					margin-left: 10PX;
				}
				.searchInp{
					width: 500px;
					float: left;
					/deep/.el-input__inner{
						border: none;
					}
				}
			}

			.btn_long {
				
				cursor: pointer;
				line-height: 50px;
				font-size: 18px;
				color: #333333;
				float: right;
				text-align: center;
				span{
					margin-left: 10px;
				}
			}
		}

		/* 活动 */
		.activity {
			margin-top: 90px;
			display: flex;
			justify-content: space-between;

			.act_zi {
				text-align: center;

				.act_title {
					margin-top: 16px;
					font-size: 20px;
					color: #333333;
				}

				.act_nero {
					font-size: 14px;
					color: #666666;
				}

				img {
					object-fit: contain;
					width: 74px;
					height: 60px;
				}
			}
		}
	}

	.carousel {
		.car_img {
			position: relative;
			width: 1200px;
			margin: 0 auto;

			&:hover .img_icon {
				display: block;
				animation: hideIndex 1s;
			}

			.img_icon {
				display: none;
				position: absolute;
				width: 100px;
				height: 200px;
				background: #70707099;
				color: #fff;
				text-align: center;
				line-height: 200px;
				font-size: 50px;
				top: 50%;
				cursor: pointer;
				transform: translate(0, -50%);

				&:hover {
					background: #606266a3;
				}
			}

			.left_img {
				left: 0px;

			}

			.right_img {
				right: 0px;
			}

			img {
				width: 100%;
				min-width: 1200px;
				display: block;
			}
		}

		.car_bot {
			width: 100%;
			min-width: 1200px;
			text-align: center;

			.car_title {
				cursor: pointer;
				display: inline-block;
				width: 170px;
				height: 52px;
				background: #F1F1F1;
				color: #444444;
				text-align: center;
				line-height: 52px;
			}

			.choose {
				background: var(--themeColor);
				color: #fff;
			}
		}
	}

	/* banner */
	.banner-box {
		width: 100%;
		// height: 550px;

		img {
			display: block;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
</style>
